import * as React from 'react'
import { Card } from '@/components/ui/Card'
import { ErrorBoundary } from '@/components/ui/ErrorBoundary'

export interface DashboardCardProps {
  title: React.ReactNode
  headerRight?: React.ReactNode
  className?: string
  children: React.ReactNode
}

export default function DashboardCard({
  title,
  headerRight,
  className = '',
  children,
}: DashboardCardProps) {
  return (
    <Card
      className={`flex w-full flex-col gap-3 rounded-[14px] p-4 shadow-none ${className}`}
    >
      <div className="flex items-baseline justify-between gap-3">
        <div className="text-[15px] font-semibold text-txt-primary">
          {title}
        </div>
        {headerRight}
      </div>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Card>
  )
}
